import { render, staticRenderFns } from "./MoleculePopupHeader.vue?vue&type=template&id=a881722e&"
import script from "./MoleculePopupHeader.vue?vue&type=script&lang=js&"
export * from "./MoleculePopupHeader.vue?vue&type=script&lang=js&"
import style0 from "./MoleculePopupHeader.vue?vue&type=style&index=0&id=a881722e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculePopupHeader.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculePopupHeader.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomSelect: require('/app/components/atoms/common/AtomSelect.vue').default,AtomsCommonAtomDropdownFilter: require('/app/components/atoms/common/AtomDropdownFilter.vue').default,AtomsCommonRangeAtomDoubleRangeSlider: require('/app/components/atoms/common/range/AtomDoubleRangeSlider.vue').default,AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default,MoleculesCommonAvailabilityMoleculeMultipleOptions: require('/app/components/molecules/common/availability/MoleculeMultipleOptions.vue').default})
